import * as React from "react";
import { gql, useMutation, ApolloError } from "@apollo/client";
import {
  RegisterMerchantMutationMutation,
  RegisterMerchantMutationMutationVariables
} from "../../../../schemaTypes";
import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";
 
interface Props {
  children: (
    data: {
      submit: (
        values: RegisterMerchantMutationMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      error?: ApolloError;
      message?: string;
    }
  ) => React.ReactElement | null;
}
 
const registerMerchantMutation = gql`
  mutation RegisterMerchantMutation(
    $firstname: String!
    $lastname: String!
    $companyName: String!
    $email: String!
    $phone: String!
    $websiteOrSocials: String
    $password: String!
    $confirmPassword: String!
    $nda: Boolean!
  ) {
    registerMerchant(
      firstname: $firstname
      lastname: $lastname
      companyName: $companyName
      email: $email
      phone: $phone
      websiteOrSocials: $websiteOrSocials
      password: $password
      confirmPassword: $confirmPassword
      nda: $nda
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;
 
export const RegisterMerchantController: React.FC<Props> = ({ children }) => {
  const [_registerMerchantMutation, { loading, error }] = useMutation<RegisterMerchantMutationMutation, RegisterMerchantMutationMutationVariables>(registerMerchantMutation);
 
  const submit = async (values: RegisterMerchantMutationMutationVariables) => {
    try {
      const { data } = await _registerMerchantMutation({ variables: values });
      if (data?.registerMerchant) {
        if (data.registerMerchant.errors && data.registerMerchant.errors.length > 0) {
          return normalizeErrors(data.registerMerchant.errors);
        }
        return {
          message: data.registerMerchant.message ?? "",
        };
      }
      return { general: "An unknown error occurred" };
    } catch (error) {
      const apolloError = error as ApolloError;
      const message =
        apolloError.graphQLErrors?.[0]?.message || apolloError.message || "An error occurred";
      return {
        general: message,
      };
    }
  };
 
  return children({ submit, loading, error });
};